<template>
  <div class="category"
       v-on:click="goTo(category.categoryName)"
       v-lazy:background-image="category.backgroundImage">
    <div class="title">
      <h3>{{ category.title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Category',
  data: function () {
    return {
      category: {
        title: 'Categoria',
        backgroundImage: require('@/assets/blank.jpg')
      },
      categoriesData: []
    }
  },
  props: {
    categoryName: String
  },
  created: function () {
    fetch('https://adminportfolio.emarketingbr.com.br/categories')
      .then((resp) => resp.json())
      .then((data) => {
        this.categoriesData = data
        this.category = this.categoriesData.filter(c => {
          return c.categoryName === this.$props.categoryName
        })
        this.category = this.category[0]
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    goTo: function (categoryName) {
      this.$router.push({ name: 'projects', params: { categoryName: categoryName } })
    }
  }
}
</script>

<style scoped lang="scss">
  .category {
    background-color: #fff;
    min-height: 250px;
    background-size: cover;
    background-position: center;
    height: fit-content;
    border-radius: 10px;
    box-sizing: border-box;
    position: relative;
    transition: all 0.4s;
    cursor: pointer;

    .title {
      background: transparent url("../assets/overlay.svg") no-repeat 50% 50%/170px auto;
      position: absolute;
      text-align: center;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-direction: row;
      flex-direction: row;
      -webkit-align-items: center;
      align-items: center;
      -webkit-justify-content: center;
      justify-content: center;
      -ms-backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      -o-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      backface-visibility: hidden;
      -ms-transform: translate3d(0, 0, 0);
      -webkit-transform: translate3d(0, 0, 0);
      -o-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      -webkit-transition: -webkit-transform 150ms ease-out;
      transition: transform 150ms ease-out;
      -webkit-transform: perspective(150px) rotateX(0deg) rotateY(0deg);
      transform: perspective(150px) rotateX(0deg) rotateY(0deg);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      h3 {
        color: #000;
        margin: 0;
        text-transform: uppercase;
        font-weight: 300;
        font-size: 1rem;
      }
    }

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
  }
</style>
